import { Vue } from 'vue-property-decorator';
import { isNull, isStringNull, find } from './utils';

export {
    isElementInViewport,
    isComponentVisible,
    notify,
    notifyStop,
    getEventHandler,
}

const isElementInViewport = (el) => {
    const elementTop = $(el).offset().top;
    const elementBottom = elementTop + $(el).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop
        && elementTop < viewportBottom;
}

const isComponentVisible = (component: Vue) => {
    if (!component.$vnode.elm) { return false; }
    const { clientWidth, clientHeight }  = (component.$vnode.elm as HTMLElement);
    return clientWidth > 0 || clientHeight > 0;
}

const notify = (e: any, handler: Function, originEventArgs: any = null) => {
    const event: any = handler || (() => { });
    if (!isNull(originEventArgs)) {
        event(e, originEventArgs);
    } else {
        event(e);
    }
}

const notifyStop = (e: any, handler: Function, handlerData: any = null) => {
    if (!isNull(handler)) {
        e.stopPropagation();
        handler(handlerData || e);
    }
}

const getEventHandler = (event: string, listeners: any): Function => {
    const words = event.split(/([A-Z]?[^A-Z]*)/g).filter(p => !isStringNull(p))
    const variations = []

    variations.push(event); // originalEvent
    variations.push(words.map(p => p.toLowerCase()).join('-')); // original-event
    variations.push(words.map(p => p.toLowerCase()).join('')); // originalevent

    const handler = find(listeners, p => variations.includes(p.key))

    return handler === undefined
        ? null
        : handler.value
}
